import { render } from "./EonConfirmEmailView.vue?vue&type=template&id=97070ac0&scoped=true"
import script from "./EonConfirmEmailView.vue?vue&type=script&lang=js"
export * from "./EonConfirmEmailView.vue?vue&type=script&lang=js"

import "./EonConfirmEmailView.vue?vue&type=style&index=0&id=97070ac0&lang=less&scoped=true"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97070ac0"]])

export default __exports__